import React, { memo } from 'react';
import { MapPin, Phone, ChevronRight } from 'lucide-react';

const Restaurants = ({ restaurants }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">🍽️ Dining Options</h2>
      {restaurants.map((restaurant, idx) => (
        <div key={idx} className="bg-white/90 dark:bg-gray-800/90 backdrop-blur rounded-lg shadow-md p-4 border border-orange-100 dark:border-gray-700">
          <div className="flex justify-between items-start mb-2">
            <h3 className="font-semibold text-lg dark:text-gray-100">{restaurant.name}</h3>
            <div className="flex gap-2">
              {restaurant.phone !== "Check Facebook" && restaurant.phone !== "Check website" && (
                <a href={`tel:${restaurant.phone}`} className="text-orange-600 dark:text-orange-400">
                  <Phone className="w-5 h-5" />
                </a>
              )}
              {restaurant.link && (
                <a href={restaurant.link} target="_blank" rel="noopener noreferrer" className="text-orange-600 dark:text-orange-400">
                  <ChevronRight className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">{restaurant.hours}</p>
          {restaurant.address && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-2 flex items-center">
              <MapPin className="w-4 h-4 mr-1" />
              {restaurant.address}
            </p>
          )}
          <ul className="space-y-1">
            {restaurant.highlights.map((highlight, hidx) => (
              <li key={hidx} className="text-sm text-gray-700 dark:text-gray-300">• {highlight}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default memo(Restaurants);